import furnitureStoreScreen1 from "../picturesOfWorks/furnitureStoreScreen1.png";
import furnitureStoreScreen2 from "../picturesOfWorks/furnitureStoreScreen2.png";
import furnitureStoreScreen3 from "../picturesOfWorks/furnitureStoreScreen3.png";
import furnitureStoreScreen4 from "../picturesOfWorks/furnitureStoreScreen4.png";
import lokalise1 from "../picturesOfWorks/lokaliseScreen1.png";
import lokalise2 from "../picturesOfWorks/lokaliseScreen2.png";
import lokalise3 from "../picturesOfWorks/lokaliseScreen3.png";
import lokalise4 from "../picturesOfWorks/lokaliseScreen4.png";
import toDoScreen1 from "../picturesOfWorks/ToDoScreen1.png";
import toDoScreen2 from "../picturesOfWorks/ToDoScreen2.png";
import toDoScreen3 from "../picturesOfWorks/ToDoScreen3.png";
import toDoScreen4 from "../picturesOfWorks/ToDoScreen4.png";

const worksData = [
  {
    id: 1,
    url: "https://phlushkov.github.io/furniture-store-practice/",
    images: [
      {
        label: "Furniture Store",
        imgPath: furnitureStoreScreen1,
      },
      {
        label: "List of products",
        imgPath: furnitureStoreScreen2,
      },
      {
        label: "Footer",
        imgPath: furnitureStoreScreen3,
      },
      {
        label: "List of products (on phone)",
        imgPath: furnitureStoreScreen4,
      },
    ],
  },
  {
    id: 2,
    url: "https://phlushkov.github.io/Flexbox/",
    images: [
      {
        label: "Lokalise",
        imgPath: lokalise1,
      },
      {
        label: "Lokalise main",
        imgPath: lokalise2,
      },
      {
        label: "Lokalise main",
        imgPath: lokalise3,
      },
      {
        label: "Footer",
        imgPath: lokalise4,
      },
    ],
  },
  {
    id: 3,
    url: "https://phlushkov.github.io/todo-list/",
    images: [
      {
        label: "TODO LIST",
        imgPath: toDoScreen1,
      },
      {
        label: "ADD TASK",
        imgPath: toDoScreen2,
      },
      {
        label: "UPDATE TASK",
        imgPath: toDoScreen3,
      },
      {
        label: "NO TASKS",
        imgPath: toDoScreen4,
      },
    ],
  },
];

export default worksData;
